export default {
	title: "Guides spirituels",
	activeGuidesCount: "Guides actifs",
	totalGuidesCount: "Total des guides",
	withMediumsCount: "Avec des médiums",
	spiritualLine: "Ligne spirituelle",
	search: "Rechercher des guides...",
	edit: "Modifier le guide",
	create: "Créer un guide",
	deleteConfirmation: "Voulez-vous vraiment supprimer le guide {name} ?",
	deactivate: "Désactiver",
	deactivateConfirmation: "Désactiver le guide {name} ? Il n'apparaîtra plus dans les listes, mais pourra être réactivé plus tard.",
	deletePermanent: "Supprimer définitivement",
	deletePermanentConfirmation: "Supprimer définitivement le guide {name} ? Cette action est irréversible.",
	deletePermanentWarning: "La suppression définitive n'est possible que si le guide n'a aucun lien (médiums, consultations, tickets ou retours). Sinon, utilisez l'option Désactiver.",
	createSuccess: "Guide créé avec succès !",
	createError: "Erreur lors de la création du guide",
	primaryMedium: "Médium principal",
	setPrimary: "Définir comme principal",
	primarySetSuccess: "Médium principal défini avec succès",
	primaryWillReplaceExisting: "En marquant comme principal, le médium/guide principal précédent dans la même ligne spirituelle sera automatiquement démarqué.",
	errorSettingPrimary: "Erreur lors de la définition du médium principal",
	confirmRemoveGuide: "Êtes-vous sûr de vouloir supprimer ce guide ?",
	empty: {
		description: "Enregistrez les guides spirituels qui travaillent dans le temple",
		title: "Aucun guide spirituel trouvé",
	},
	errorActivatingGuide: "Erreur lors de l'activation du guide",
	errorDeactivatingGuide: "Erreur lors de la désactivation du guide",
	errorLoadingAvailableGuides: "Erreur lors du chargement des guides disponibles",
	errorLoadingGuides: "Erreur lors du chargement des guides",
	errorRemovingGuide: "Erreur lors de la suppression du guide",
	errorSavingGuide: "Erreur lors de l'enregistrement du guide",
	guide: "Guide",
	guideActivatedSuccess: "Guide activé avec succès",
	guideAddedSuccess: "Guide ajouté avec succès",
	guideDeactivatedSuccess: "Guide désactivé avec succès",
	guideRemovedSuccess: "Guide supprimé avec succès",
	guideUpdatedSuccess: "Guide mis à jour avec succès",
	noGuidesFound: "Aucun guide trouvé",
	primaryGuide: "Guide principal",
	form: {
		nameLabel: "Nom du guide",
		nameHint: "Saisissez le nom du guide",
		spiritualLineLabel: "Ligne spirituelle",
		spiritualLineHint: "Sélectionnez la ligne spirituelle",
		personLabel: "Personne (optionnel)",
		personHint: "Sélectionnez une personne associée au guide",
		primaryMediumLabel: "Médium principal",
		willBePrimaryMedium: "Cette personne sera automatiquement définie comme médium principal du guide",
		descriptionLabel: "Description",
		descriptionHint: "Description du guide",
		isActiveLabel: "Guide actif",
		associatedPersonHint: "Cette personne est déjà associée au guide et ne peut pas être modifiée",
		associatedPersonTooltip: "Pour modifier la personne associée, utilisez la gestion des personnes du guide",
		isPrimaryLabel: "Médium principal",
		noPersonFound: "Aucune personne trouvée",
		personSearchPlaceholder: "Saisissez pour rechercher une personne...",
	},
	filter: {
		all: "Tous",
		active: "Actifs",
		inactive: "Inactifs",
	},
	validation: {
		nameRequired: "Le nom est obligatoire",
		nameMaxLength: "Le nom doit contenir au maximum 100 caractères",
		spiritualLineRequired: "La ligne spirituelle est obligatoire",
		descriptionMaxLength: "La description doit contenir au maximum 500 caractères",
	},
	tabs: {
		overview: "Aperçu",
		persons: "Personnes",
	},
	details: {
		basicInfo: "Informations de base",
		noPeopleAssociated: "Aucune personne associée à ce guide",
		totalPeople: "Total des personnes",
		activePeople: "Personnes actives",
		totalConsultations: "Consultations",
	},
	messages: {
		loading: "Chargement du guide...",
		created: "Guide {name} créé avec succès",
		updated: "Guide {name} mis à jour avec succès",
		deleted: "Guide {name} supprimé avec succès",
		deactivated: "Guide {name} désactivé avec succès",
		deletedPermanent: "Guide {name} supprimé définitivement",
		createError: "Erreur lors de la création du guide",
		updateError: "Erreur lors de la mise à jour du guide",
		deleteError: "Erreur lors de la suppression du guide",
		deactivateError: "Erreur lors de la désactivation du guide",
		deletePermanentError: "Erreur lors de la suppression définitive du guide",
	},
	errors: {
		invalidId: "Identifiant de guide invalide",
		fetchError: "Erreur lors du chargement des données du guide",
	},
};
